// src/pages/PesquisaJurisprudencia/utils/helpers.js

export const formatarData = (data) => {
  if (!data) return 'N/A';
  return new Date(data).toLocaleDateString('pt-PT');
};

export const formatarNumero = (numero) => {
  if (!numero) return '0';
  return new Intl.NumberFormat('pt-PT').format(numero);
};

export const abrirUrlOriginal = (url) => {
  if (url) window.open(url, '_blank', 'noopener,noreferrer');
};